import React, { ChangeEvent } from 'react'
import CardNew from 'presentation/shared/components/CardNew'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import TextFieldNew from 'presentation/shared/components/TextFieldNew'
import DividerNew from 'presentation/shared/components/DividerNew'
import { ReactComponent as TrashIcon } from 'presentation/assets/icons/new-trash-green.svg'
import { Medication } from 'main/factories/pages/doctor/ambulatory-authorization/ambulatory-authorization-dashboard-factory'
import * as S from './styles'

type MedicationCardProps = {
  medication: Medication
  handleQuantityChange?: (
    code: number,
    e: ChangeEvent<HTMLInputElement>
  ) => void
  handleQuantityBlur?: (code: number, e: ChangeEvent<HTMLInputElement>) => void
  removeMedication?: (code: number) => void
}

export const MedicationCard = ({
  medication,
  handleQuantityChange,
  handleQuantityBlur,
  removeMedication
}: MedicationCardProps) => {
  return (
    <CardNew key={medication?.code} style={{ width: '100%' }} shadow="satin">
      <S.CardHeader>
        <SupportTextNew color="neutral500" size="xsmall" weight="bold">
          {medication?.name}
        </SupportTextNew>
        {removeMedication && (
          <S.TrashContainer onClick={() => removeMedication(medication?.code)}>
            <TrashIcon width="24" height="24" />
          </S.TrashContainer>
        )}
      </S.CardHeader>

      <DividerNew marginTop="8px" marginBottom="16px" />

      <S.CardContent>
        <S.Row>
          <div>
            <TextFieldNew
              label="Código TUSS"
              labelSize="xxsmall"
              labelOverlapping
              baselineStyle
              // style={{ width: '140px' }}
              value={medication?.code}
              disabled
              requiredColor="neutral800"
            />
          </div>

          <div>
            <TextFieldNew
              label="Quantidade"
              labelSize="xxsmall"
              labelOverlapping
              baselineStyle
              type="number"
              // style={{ width: '80px' }}
              value={medication?.quantity}
              onChange={(e) =>
                handleQuantityChange && handleQuantityChange(medication.code, e)
              }
              onBlur={(e) =>
                handleQuantityBlur && handleQuantityBlur(medication.code, e)
              }
              requiredColor="neutral800"
              min={1}
              disabled={!handleQuantityChange}
              inputMode="numeric"
              pattern="[0-9]*"
            />
          </div>
        </S.Row>
        <S.Row>
          {medication?.dosage && (
            <div>
              <TextFieldNew
                label="Dosagem"
                labelSize="xxsmall"
                labelOverlapping
                baselineStyle
                // style={{ width: '140px' }}
                value={medication?.dosage}
                disabled
                requiredColor="neutral800"
              />
            </div>
          )}
          {medication?.routeOfAdministration && (
            <div>
              <TextFieldNew
                label="Via de administração"
                labelSize="xxsmall"
                labelOverlapping
                baselineStyle
                // style={{ width: '140px' }}
                value={medication?.routeOfAdministration}
                disabled
                requiredColor="neutral800"
              />
            </div>
          )}
        </S.Row>
      </S.CardContent>
    </CardNew>
  )
}
